// @flow
import OrgsListTableCellSettings from './OrgsListTableCellSettings';

export default OrgsListTableCellSettings;
